<template>
    <div class="make">
        <div class="contact_blank clearfix"
             v-if='!user_id'>
            <span :class="[(aind+1)%4===0?'blank margin0':'blank','answer']"
                  v-for="(answer,aind) in answers"
                  v-html="answer">{{answer}}</span>
        </div>
        <div class="contact_blank clearfix"
             v-if='user_id'>
            <span v-for='(make,aind) in user_answers'
                  :class="[(aind+1)%4===0?'blank margin0':'blank','inspect_myColor']"
                  v-html="make.replace(/\d\,/g, '')"></span>
        </div>
        <template v-if="!is_answer">
            <p class="contact_remind">点击下方单词填充到上方横线</p>
            <div class="contact_words clearfix">
                <template v-if="type==10">
                    <span class="word"
                          v-for="word in ask.words"
                          v-html="word">{{word}}</span>
                </template>
                <template v-else>
                    <p class="sentence"
                       v-for="sentence in ask.words"
                       v-html="sentence">{{sentence}}</p>
                </template>
            </div>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/loadingS.vue';
import noResouse from 'COMPONENTS/noResouse.vue';

export default {
    data () {
        return {
            answers: [],
            user_answers: [],
        }
    },
    props: ['ask', 'is_answer', 'type', 'user_id', 'myColor'],
    components: {
        loadingS, noResouse
    },
    methods: {},
    created () {
        if (this.user_id && this.ask.stu_answer.indexOf(',') > -1) {
            if (!this.ask.is_new) {
                var answerArr;
                answerArr = this.ask.stu_answer.split(',');
                answerArr.forEach(m => {
                    if (m.indexOf('|') > -1) {
                        var _a = m.split('|');
                        this.user_answers.push(_a[0]);
                    }
                });
            }
        }
        if (this.ask.is_new == 1) {
            this.user_answers = this.ask.stu_answer.split('|');
        }
        this.answers = this.ask.answer;
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.make {
    padding-bottom: 34px / $ppr;
    .contact_blank {
        padding-top: 20px / $ppr;
        border-top: 1px / $ppr solid #dcdcdc;
        .blank {
            display: block;
            float: left;
            margin-left: 24px / $ppr;
            min-width: 150px / $ppr;
            min-height: 60px / $ppr;
            line-height: 60px / $ppr;
            border-bottom: 1px / $ppr solid #333;
            box-sizing: border-box;
            &.answer {
                text-align: center;
                font-size: 30px / $ppr;
                color: #999;
                border-bottom: 1px / $ppr solid #cccccc;
            }
            &.inspect_myColor {
                text-align: center;
                font-size: 30px / $ppr;
                color: #5d89ef;
                border-bottom: 1px / $ppr solid #5d89ef;
            }
        }
    }
    .contact_remind {
        margin-top: 60px / $ppr;
        text-align: center;
        font-size: 24px / $ppr;
        color: #ff6600;
    }
    .contact_words {
        padding-right: 24px / $ppr;
        .word {
            display: block;
            float: left;
            margin-left: 24px / $ppr;
            margin-top: 24px / $ppr;
            padding: 0 56px / $ppr;
            height: 72px / $ppr;
            line-height: 72px / $ppr;
            font-size: 30px / $ppr;
            color: #fff;
            background: #5e89ef;
            border-radius: 20px / $ppr;
            box-sizing: border-box;
        }
        .sentence {
            margin: 24px / $ppr 0 0 24px / $ppr;
            padding: 32px / $ppr 24px / $ppr;
            font-size: 30px / $ppr;
            color: #fff;
            background: #5e89ef;
            border-radius: 20px / $ppr;
            word-wrap: break-word;
        }
    }
}
</style>
